(ns common.schema.entities.ai-job-enrichment.schema
  (:require
   [common.schema.entities.integration.ai-options :as ai-options]
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (vec
   (concat
    (su/text-simple-field :ai-job-enrichment/request-id
                          "Request id"
                          (system-controlled {:authorization su/access-system-user}))
    (su/single-ref-field :ai-job-enrichment/account
                         "Requested by"
                         [:entity.type/account]
                         (system-controlled {:authorization su/access-system-user}))
    (su/keyword-field :ai-job-enrichment/status
                      "Status"
                      ai-options/status-options
                      (system-controlled {:authorization su/access-system-user}))
    ;; Why a failed job failed, so the client shows a specific reason. Set with
    ;; the failed status; absent on a job that did not fail.
    (su/keyword-field :ai-job-enrichment/failure-reason
                      "Failure reason"
                      ai-options/failure-reason-options
                      (system-controlled {:authorization su/access-system-user}))
    (su/text-simple-field :ai-job-enrichment/label
                          "Label"
                          (system-controlled {:authorization su/access-system-user}))
    ;; EDN snapshot: {:entity-type :template-kw :draft :rule-context} — what was
    ;; requested, frozen so the queued job does not reread mutable inputs.
    (su/text-edn-field :ai-job-enrichment/request-context
                       "Request context"
                       (system-controlled {:authorization su/access-system-user}))
    ;; EDN: sanitized suggestions keyed by target slug, plus the descriptor label.
    (su/text-edn-field :ai-job-enrichment/suggestions
                       "Suggestions"
                       (system-controlled {:authorization su/access-system-user}))
    ;; The entity the job's result is applied to: one the result created, once
    ;; it exists, or one it enriches, merges into or fills. Applying again after
    ;; a failure goes to this entity rather than creating another.
    (su/single-ref-field :ai-job-enrichment/target
                         "Target"
                         [:entity.type/any]
                         (system-controlled {:authorization su/access-system-user}))
    ;; Set when the user saves or discards the result, so it leaves their list
    ;; of background processes.
    (su/boolean-field :ai-job-enrichment/resolved?
                      "Resolved"
                      (system-controlled {:authorization su/access-system-user})))))
